export { default as EN } from "./en.json";
export const ACCOUNTS_NAMESPACE = "accounts";
